import { StorageKey, useStoredValue } from 'app/lib/storage';
import type { SpecificNavigationProp } from 'app/types/navigation';
import { isWhiteLabel } from 'app/utils/helpers';

export function useBorrowerAvailabilityReminder(
  navigation: SpecificNavigationProp<'loan-dates-picker'>,
  enabled: boolean,
) {
  const [hasSeenPopup, setHasSeenPopup] = useStoredValue<boolean>(
    StorageKey.RefrainBlockedDatesPopupWasShownBorrower,
    false,
  );

  const isEligible = enabled && isWhiteLabel();
  const needsReminder = isEligible && hasSeenPopup !== true;
  const isLoadingReminderPreference = isEligible && hasSeenPopup === undefined;

  const showReminder = () => {
    if (!isEligible || hasSeenPopup !== false || !navigation.isFocused()) return;
    setHasSeenPopup(true);
    navigation.navigate('refrainOfferAvailabilityPopup', { who: 'borrower' }, { pop: true });
  };

  return { needsReminder, isLoadingReminderPreference, showReminder };
}
